import { Entry, SizeEntry , TypeEntry} from "./Entry"

const EntryView = {
    View: Entry,
    SizeEntry,
    TypeEntry,
}

export default EntryView;